import { ViewSupport43Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport43Container"
export function ViewSupport43Page() {
    return (
        <ViewSupport43Container />
    )
}